import {Injectable} from '@angular/core'

import {Observable} from 'rxjs'
import {map} from 'rxjs/operators'

import {TerminalData} from './terminal-data.interface'
import {
  TerminalService,
  GetTerminalsRequest,
} from '@app/core/services/terminal/terminal.service'
import {SearchFilter} from '@app/core/services/search/search-filter.interface'
import {
  GenericListService,
  LoadRequest,
  LoadResult,
} from '@app/core/services/generic-list.service'
import {NotificationService} from '@app/core/services/notification.service'
import {LoggerService} from '@app/core/services/logger.service'
import {ContextService} from '@app/core/services/context.service'
import {ContractEntry} from '@app/core/services/rest-api'

export {TerminalData}

@Injectable()
export class TerminalListService extends GenericListService<TerminalData> {
  filter: SearchFilter = null

  constructor(
    private restSvc: TerminalService,
    protected notify: NotificationService,
    protected contextSvc: ContextService,
    protected logger: LoggerService,
  ) {
    super(notify, logger)
  }

  retrieve(request: LoadRequest): Observable<LoadResult<TerminalData>> {
    // build the service request
    const svcRequest: GetTerminalsRequest = {
      offset: request.offset,
      results: request.count,
      domain: request.domain,
      contracts: true,
    }

    if (this.filter) {
      svcRequest.search = this.filter.query
      svcRequest.sort = this.filter.sort
      svcRequest.asc = this.filter.asc
    }

    return this.restSvc.getTerminals(svcRequest).pipe(
      map((res) => {
        const result: LoadResult<TerminalData> = {
          total: res.count,
          items: res.results.map((terminal) => {
            return {
              terminalid: terminal.id,
              serialNumber: terminal.serialNumber,
              domain: terminal.domain,
              model: {
                code: terminal.model.code,
                description: terminal.model.description,
                productionCode: terminal.productionCode,
              },
              type: terminal.terminalType,
              attributes: terminal.attributes,
              connected: terminal.sync ? terminal.sync.connected : undefined,
              message: terminal.sync ? terminal.sync.message : undefined,
              lastConnected: terminal.sync
                ? terminal.sync.lastConnected
                : undefined,
              lastDisconnected: terminal.sync
                ? terminal.sync.lastDisconnected
                : undefined,
              lastBoot: terminal.sync ? terminal.sync.lastBoot : undefined,
              syncInProgress: terminal.sync
                ? terminal.sync.inProgress
                : undefined,
              syncPending: terminal.sync ? terminal.sync.pending : false,
              deviceState: terminal.sync
                ? terminal.sync.deviceState
                : undefined,

              configStatus: terminal.config ? terminal.config.updateStatus : [],

              gprsOperator: terminal.data
                ? terminal.data['Modem Operator']
                : undefined,
              gprsCCID: terminal.data ? terminal.data['Modem CCID'] : undefined,
              siteName: terminal.site ? terminal.site.name : undefined,
              site: terminal.site || undefined,
              siteLabels: terminal.site ? terminal.site.labels : undefined,
              siteDescription: terminal.site
                ? terminal.site.description
                : undefined,
              primaryTid: terminal.site
                ? this.getPrimaryTid(terminal.site.contractEntries)
                : undefined,
              contractInfo: terminal.site
                ? terminal.site.contractEntries.map((elem) => {
                    return {
                      domain: elem.contract ? elem.contract.domain : undefined,
                      status: elem.status,
                      name: elem.contract ? elem.contract.name : undefined,
                      type: elem.contract
                        ? {
                            name: elem.contract.type.name,
                            code: elem.contract.type.code,
                          }
                        : undefined,
                      data: elem.data,
                    }
                  })
                : undefined,
              terminalData: terminal.data,
              configInfo: terminal.config,
              warrantyExpirationBeginDate: terminal.warrantyExpirationBeginDate,
            } //end TerminalData Object
          }), //end map
        } //end LoadResult Object

        return result
      }), //end map
    )
  }

  getPrimaryTid(ce: ContractEntry[]): string {
    var tid: string

    ce.map((elem) => {
      if (elem.data['tid']) {
        tid = elem.data['tid']
      }
    })

    return tid
  }
}
